var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckStep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1808 0.000819997C17.8326 0.0115464 17.5025 0.154643 17.2604 0.39953C13.9813 3.61179 10.6997 6.80828 7.41697 10.0211L2.33323 5.88018C2.06005 5.65766 1.7077 5.5504 1.35349 5.58212C0.999285 5.61361 0.672613 5.78159 0.444998 6.04861C0.21758 6.31587 0.108077 6.66028 0.140294 7.00651C0.172749 7.35273 0.344598 7.67204 0.617778 7.89429L6.64289 12.8021C6.9002 13.0125 7.22895 13.1209 7.56399 13.1058C7.89905 13.0906 8.21611 12.9532 8.45264 12.7204C12.021 9.22486 15.5913 5.75014 19.1639 2.25043C19.4257 2.00325 19.5733 1.66254 19.5728 1.30673C19.5723 0.950926 19.4236 0.610641 19.1609 0.364375C18.8982 0.118121 18.5443 -0.0131092 18.1805 0.00103574L18.1808 0.000819997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStep);
export default __webpack_public_path__ + "static/media/CheckStep.677914eca6dbb182cbbe7225a1d6c346.svg";
export { ForwardRef as ReactComponent };